import { render, staticRenderFns } from "./auth-view.vue?vue&type=template&id=2a48406a"
import script from "./auth-view.vue?vue&type=script&lang=ts"
export * from "./auth-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports